import {GET_DRIVER_TRIPS_COMPLETED_LOADING , GET_DRIVER_TRIPS_COMPLETED_ERROR , GET_DRIVER_TRIPS_COMPLETED , GET_DRIVER_TRIPS_IN_PROGRESS , GET_DRIVER_TRIPS_IN_PROGRESS_ERROR , GET_DRIVER_TRIPS_IN_PROGRESS_LOADING , GET_DRIVER_TRIPS_DECLINED_LOADING , GET_DRIVER_TRIPS_DECLINED_ERROR , GET_DRIVER_TRIPS_DECLINED} from 'app/types'

const initialState = {
    completed : {
        data:[],
        loading:true,
        error : null
    },
    inProgress : {
        data:[],
        loading:true,
        error : null
    },
    declined : {
        data:[],
        loading:true,
        error : null
    }

}

export default function driverTripsReducer (state = initialState, action) {

    switch(action.type){
        case GET_DRIVER_TRIPS_COMPLETED_LOADING:
            return {
                ...state,
                completed: {
                    ...state.completed ,
                    loading : true ,
                    error : null
                }
            }
        case GET_DRIVER_TRIPS_COMPLETED_ERROR :
            return {
                ...state,
                completed: {
                    ...state.completed ,
                    loading : false ,
                    error : action.payload
                }
            }
        case GET_DRIVER_TRIPS_COMPLETED :
            return {
                ...state,
                completed: {
                    ...state.completed ,
                    data : action.payload,
                    loading : false ,
                    error : null
                }
            }
        case GET_DRIVER_TRIPS_IN_PROGRESS_LOADING:
            return {
                ...state,
                inProgress: {
                    ...state.completed ,
                    loading : true ,
                    error : null
                }
            }
        case GET_DRIVER_TRIPS_IN_PROGRESS_ERROR :
            return {
                ...state,
                inProgress: {
                    ...state.completed ,
                    loading : false ,
                    error : action.payload
                }
            }
        case GET_DRIVER_TRIPS_IN_PROGRESS :
            return {
                ...state,
                inProgress: {
                    ...state.completed ,
                    data : action.payload,
                    loading : false ,
                    error : null
                }
            }
        case GET_DRIVER_TRIPS_DECLINED_LOADING:
            return {
                ...state,
                declined: {
                    ...state.completed ,
                    loading : true ,
                    error : null
                }
            }
        case GET_DRIVER_TRIPS_DECLINED_ERROR :
            return {
                ...state,
                declined: {
                    ...state.completed ,
                    loading : false ,
                    error : action.payload
                }
            }
        case GET_DRIVER_TRIPS_DECLINED :
            return {
                ...state,
                declined: {
                    ...state.completed ,
                    data : action.payload,
                    loading : false ,
                    error : null
                }
            }
        default: return state
    }

}

